// extracted by mini-css-extract-plugin
module.exports = {"exception":"exception___1TC0F","imgBlock":"imgBlock___2gXIk","imgEle":"imgEle___33EO7","content":"content___1DQD7","desc":"desc___1Tc-A","actions":"actions___GQZlP"};